//  权限定义
//  注意：这里的key是唯一的，不可重复；定义时要将一个页面中的权限定义在一起，方便查找
class PermissionDefinition {
	// 自有自运业务发布
	selftransportBusinessRelease = 'selftransport-business-release'
	// 自有自运业务发布-保存
	selftransportBusinessReleaseSave = 'selftransport-business-release-save'
	// 自有自运业务发布-删除
	selftransportBusinessReleaseDelete = 'selftransport-business-release-delete'

	// 开票业务发布
	invoiceBusinessIssue = 'invoice-business-issue'
	// 开票业务发布-保存
	invoiceBusinessIssueSave = 'invoice-business-issue-save'
	// 开票业务发布-删除
	invoiceBusinessIssueDelete = 'invoice-business-issue-delete'
	// 开票业务回单确认
	invoiceBusinessIssueRecieptConfirm = 'invoice-business-issue-reciept-confirm'

	// 不开票业务发布
	notInvoiceBusinessIssue = 'notinvoice-business-issue'
	// 不开票业务发布-保存
	notInvoiceBusinessIssueSave = 'notinvoice-business-issue-save'
	// 不开票业务发布-删除
	notInvoiceBusinessIssueDelete = 'notinvoice-business-issue-delete'
	// 不开票业务回单确认
	noInvoiceBusinessIssueRecieptConfirm = 'noinvoice-business-issue-reciept-confirm'

	// 客户管理
	customerManagement = 'customer-management'
	// 客户管理-保存
	customerManagementSave = 'customer-management-save'
	// 客户管理-删除
	customerManagementDelete = 'customer-management-delete'

	// 变更单
	transOrderManagement = 'transorder-management'
	// 变更单-确认
	transOrderManagementConfirmation = 'transorder-management-confirmation'
	// 变更单-查看
	transOrderManagementView = 'transorder-management-view'

	// 运费审核 2020-10-15new
	transFeeApproval = 'trans-fee-approval'
	// 运费审核-查询 2020-10-15new
	transFeeApprovalSearch = 'trans-fee-approval-search'
	// 运费审核-通过/拒绝 2020-10-15new
	transFeeApprovalPassReject = 'trans-fee-approval-passreject'

	// 业务明细统计报表
	businessDetailStatisticalReport = 'businessdetail-statistical-report'
	// 业务明细统计报表-查询
	businessDetailStatisticalReportSearch = 'businessdetail-statistical-report-search'

	// 结算费用明细统计报表
	balanceFeeDetailStatisticalReport = 'balancefeedetail-statistical-report'
	// 结算费用明细统计报表-查询
	balanceFeeDetailStatisticalReportSearch = 'balancefeedetail-statistical-report-search'

	// 对账单管理
	statementManagement = 'statement-management'
	// 对账单管理-查询
	statementManagementSearch = 'statement-management-search'
	// 对账单管理-对账
	statementManagementReconciliation = 'statement-management-reconciliation'

	// 结算管理 2020-10-15new
	customerBalanceManagement = 'customer-balance-management'
	// 结算管理-查询 2020-10-15new
	customerBalanceManagementSearch = 'customer-balance-management-search'

	// 承运方
	carrierManagement = 'carrier-management'
	// 开票业务受理
	invoiceBusinessManagement = 'invoicebusiness-management'
	// 开票业务受理-受理
	invoiceBusinessManagementAcceptance = 'invoicebusiness-management-acceptance'
	// 开票业务受理-查看
	invoiceBusinessManagementView = 'invoicebusiness-management-view'

	// 不开票业务受理
	notInvoiceBusinessManagement = 'notinvoicebusiness-management'
	// 不开票业务受理-受理
	notInvoiceBusinessManagementAcceptance = 'notinvoicebusiness-management-acceptance'
	// 不开票业务受理-查看
	notInvoiceBusinessManagementView = 'notinvoicebusiness-management-view'

	// 业务明细统计报表
	carrierBusinessDetailStatisticalReport = 'carrierbusinessdetail-statistical-report'
	// 业务明细统计报表-查询
	carrierBusinessDetailStatisticalReportSearch = 'carrierbusinessdetail-statistical-report-search'

	// 结算费用明细统计报表
	carrierBalanceFeeDetailStatisticalReport = 'carrierbalancefeedetail-statistical-report'
	// 结算费用明细统计报表-查询
	carrierBalanceFeeDetailStatisticalReportSearch = 'carrierbalancefeedetail-statistical-report-search'

	// 对账单管理
	carrierStatementManagement = 'carrierstatement-management'
	// 对账单管理-对账
	carrierStatementManagementReconciliation = 'carrierstatement-management-reconciliation'
	// 对账单管理-保存
	carrierStatementManagementSave = 'carrierstatement-management-save'
	// 对账单管理-删除
	carrierStatementManagementDelete = 'carrierstatement-management-delete'

	// 结算管理 2020-10-15new
	carrierBalanceManagement = 'carrier-balance-management'
	// 结算管理-查询 2020-10-15new
	carrierBalanceManagementSearch = 'carrier-balance-management-search'
	// 结算管理-保存 2020-10-15new
	carrierBalanceManagementSave = 'carrier-balance-management-save'
	// 结算管理-删除 2020-10-15new
	carrierBalanceManagementDelete = 'carrier-balance-management-delete'


	// 管理中心
	managementCenter = 'management-center'
	// 组织架构
	organizationalStructure = 'organizational-structure'
	// 组织架构-保存
	organizationalStructureSave = 'organizational-structure-save'
	// 组织架构-删除
	organizationalStructureDelete = 'organizational-structure-delete'

	// 权限管理
	authorityManagement = 'authority-management'
	// 权限管理-保存
	authorityManagementSave = 'authority-management-save'
	// 权限管理-删除
	authorityManagementDelete = 'authority-management-delete'

	// 行政区域管理
	administrativeRegionManagement = 'administrative-region-management'

	// 承运方线路配置
	carrierLineConfiguration = 'carrierline-configuration'
	// 承运方线路配置-保存
	carrierLineConfigurationSave = 'carrierline-configuration-save'
	// 承运方线路配置-删除
	carrierLineConfigurationDelete = 'carrierline-configuration-delete'

	// 订单管理
	orderManagement = 'order-management'
	// 订单管理-指派
	orderManagementAssignment = 'order-management-assignment'
	// 订单管理-价格变更 2020-10-15new
	orderManagementPriceChange = 'order-management-price-change'

	// 变更单查看 2020-10-15new
	changeOrderView = 'change-order-view'

	// 业务明细统计报表
	managementBusinessDetailStatisticalReport = 'managementbusinessdetail-statistical-report'
	// 业务明细统计报表-查询
	managementBusinessDetailStatisticalReportSearch = 'managementbusinessdetail-statistical-report-search'

	// 对账单管理
	managementStatementManagement = 'managementstatement-management'
	// 对账单管理-对账
	managementStatementManagementReconciliation = 'managementstatement-management-reconciliation'
	// 对账单管理-查询
	managementStatementManagementView = 'managementstatement-management-view'
	// 对账单管理-审核
	managementStatementManagementApproval = 'managementstatement-management-approval'

	// 结算管理 2020-10-15new
	balanceManagement = 'balance-management'
	// 结算管理-查询 2020-10-15new
	balanceManagementSearch = 'balance-management-search'
}

const permissionDefinition = new PermissionDefinition()
export default permissionDefinition
